import React from 'react';
import { Text, TextButton } from '@wix/wix-base-ui';

interface TemplateProps {
  title?: string;
  description?: string;
  learnMoreText?: string;
  onLearnMore?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

const AddTooltip: React.FC<TemplateProps> = ({
  title,
  description,
  learnMoreText,
  onLearnMore,
  onMouseEnter,
  onMouseLeave,
}) => {
  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className="add-tooltip-pp add-tooltip-pp_se-madefor-font"
    >
      {title && (
        <div className="add-tooltip-pp_se-madefor-font__title">
          <Text
            skin="secondary"
            size="medium"
            weight="bold"
            enableEllipsis={false}
          >
            {title}
          </Text>
        </div>
      )}
      {description && (
        <div>
          <Text skin="secondary" size="small" enableEllipsis={false}>
            {description}
          </Text>
        </div>
      )}
      {onLearnMore && (
        <div>
          <TextButton size="small" onClick={onLearnMore}>
            {learnMoreText || 'NewPages_Panel_Add_Folder_Learnmore'}
          </TextButton>
        </div>
      )}
    </div>
  );
};

AddTooltip.displayName = 'addTooltip';

export default AddTooltip;
